import { render, staticRenderFns } from "./SigJoinRequest.vue?vue&type=template&id=3f1a5316&"
import script from "./SigJoinRequest.vue?vue&type=script&lang=js&"
export * from "./SigJoinRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports